//removes tail zeros from the end of the float
export const deleteTailZeros = (value: string): string => {
  return value.replace(/(\.0+)$/gi, '');
};
